<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import type { TodoStatus } from '@/api'

const { t } = useI18n()
const props = defineProps<{ status: TodoStatus | null; disabled?: boolean }>()
const emit = defineEmits<{ toggle: [] }>()

const checked = computed(() => props.status === 'COMPLETED' || props.status === 'CANCELLED')
</script>

<template>
  <button
    type="button"
    role="checkbox"
    class="ui-checkbox"
    :class="{ 'is-cancelled': status === 'CANCELLED' }"
    :aria-checked="checked"
    :aria-label="checked ? t('row.markNotDone') : t('row.markDone')"
    :disabled="disabled"
    @click.stop="emit('toggle')"
  >
    <span v-if="status === 'COMPLETED'">✓</span>
    <span v-else-if="status === 'CANCELLED'">✕</span>
  </button>
</template>
